module.exports = __webpack_public_path__ + "gl.47d7de15bb03a1c19586.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/gl.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/gl.svg
// module chunks = styles